import type {AfriexOTCTrade, AfriexQueryParams} from '@/types';

export interface OTCTradeListProps {
  /** Whatever the fetch threw. A caught value is `unknown`, not an `Error`. */
  error: unknown;
  isLoading: boolean;
  isSearch: boolean;
  isPageReset: boolean;
  pageInfo: {
    total: number;
    page: number;
  };
  showPagination: boolean;
  otcTradeList: AfriexOTCTrade[];
  /**
   * Async: the hook awaits the OTC trade request. Declared honestly so callers
   * can sequence on it, matching `handleApprove` below.
   */
  fetchAllOTCTrades: (params: AfriexQueryParams) => Promise<void>;
  setPage: (page: number) => void;
  filterCount: number;
  currentFilters: AfriexQueryParams;
  filtersToApply: AfriexQueryParams;
  clearFilters: () => void;
  selectAppliedFilters: (
    name: string,
    value: string | Date | undefined,
  ) => void;
  selectCurrentFilters: (
    name: string,
    value: string | Date | undefined,
  ) => void;
  /** Returns whether the filters were applied; false when validation rejected them. */
  handleApplyFilters: () => boolean;
  handleAutoComplete?: (search: string) => void;
  handleApprove: (id: string) => Promise<void>;
}

export enum OTCTradeActionType {
  UPDATE_OTC_TRADE = 'UPDATE_OTC_TRADE',
}

export interface UpdateOTCTradeAction {
  type: OTCTradeActionType.UPDATE_OTC_TRADE;
  payload: Partial<AfriexOTCTrade>;
}

export type OTCTradeAction = UpdateOTCTradeAction;

export type OTCFiltersProps = {
  filterCount: number;
  currentFilters: AfriexQueryParams;
  filtersToApply: AfriexQueryParams;
  clearFilters: () => void;
  selectAppliedFilters: (name: string, date: string | Date | undefined) => void;
  /** Returns whether the filters were applied; false when validation rejected them. */
  handleApplyFilters: () => boolean;
  selectCurrentFilters: (
    name: string,
    value: string | Date | undefined,
  ) => void;
  handleAutoComplete?: (search: string) => void;
};
